export default __webpack_public_path__ + "static/media/search.98a7b4a7.svg";